import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SummaryService {
  private readonly summaryEvent$: EventEmitter<string> = new EventEmitter();

  get setActiveEvent(): Observable<string> {
    return this.summaryEvent$.asObservable();
  }

  public setActive(id: string): void {
    this.summaryEvent$.next(id);
  }
}
